module.exports = __webpack_public_path__ + "img/pic_2.feb5e117.jpg";